import React from "react";
import useMonthlyStats from "../hooks/useMonthlyStats";
import { Card, CardContent, Typography, Divider, Box } from "@mui/material";

export default function MonthlySummary() {
  const stats = useMonthlyStats();

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        📊 Monthly Summary
      </Typography>

      {Object.keys(stats).length === 0 && (
        <Typography>No receipts found.</Typography>
      )}

      {Object.entries(stats).map(([month, data]) => (
        <Card key={month} sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="h6">{month}</Typography>
            <Typography>Total spent: ${data.totalSpent.toFixed(2)}</Typography>
            <Typography>Receipts: {data.count}</Typography>
            <Divider sx={{ my: 1 }} />
            <Typography variant="subtitle2">Top Vendors:</Typography>
            <Divider sx={{ my: 1 }} />
            <Typography variant="subtitle2">Categories:</Typography>
            {Object.entries(data.categories)
              .sort((a, b) => b[1] - a[1])
              .map(([cat, count]) => (
                <Typography key={cat}>
                  {cat}: {count}
                </Typography>
              ))}

            {Object.entries(data.vendors)
              .sort((a, b) => b[1] - a[1])
              .slice(0, 3)
              .map(([vendor, count]) => (
                <Typography key={vendor}>
                  {vendor}: {count}
                </Typography>
              ))}
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}
